<template>
  <div class="delivery-returns-information">
    <icon-delivery />

    <div class="delivery-returns-information__text">
      <p
        class="text-body-2xs"
        v-html="updateShippingThreshold(freeDeliveryThresholdText)"
      />

      <p
        class="text-body-2xs delivery-returns-information__text-light"
        v-html="updateDeliveryText(standardDeliveryText)"
      />
    </div>
  </div>
</template>

<script>

import IconDelivery from '~icons/misc/delivery.svg'

/**
 * Vue: Delivery and returns information (delivery-returns-information)
 * -----------------------------------------------------------------------------
 * Delivery and returns information.
 *
 * @param {String} standardDeliveryText - Standard delivery & returns information.
 * @param {String} freeDeliveryThresholdText - Free delivery threshold information.
 * @param {String} shippingPrice - Deliver price.
 * @param {String} freeShippingThreshold - Shipping threshold rate.
 */
export default {
  name: 'DeliveryAndReturnsInformation',
  components: {
    IconDelivery,
  },

  props: {
    standardDeliveryText: {
      type: String,
      default: '',
    },
    freeDeliveryThresholdText: {
      type: String,
      default: '',
    },
    shippingPrice: {
      type: String,
      default: '',
    },
    freeShippingThreshold: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.updateDeliveryText(this.standardDeliveryText)
    this.updateShippingThreshold(this.freeShippingThreshold)
  },

  methods: {

    /**
     * Update standard delivery text.
     * @param {String} standardDeliveryText - Standard delivery and returns information.
     * @return {String}
     */
    updateDeliveryText(standardDeliveryText) {
      if (!this.standardDeliveryText) {
        return
      }

      return standardDeliveryText.replace('{delivery_amount}', this.shippingPrice)
    },

    /**
     * Update free shipping threshold text.
     * @param {String} freeDeliveryThresholdText - Free shipping threshold information.
     * @return {String}
     */
    updateShippingThreshold(freeDeliveryThresholdText) {
      if (!this.freeDeliveryThresholdText) {
        return
      }

      return freeDeliveryThresholdText.replace('{threshold_amount}', this.freeShippingThreshold)
    },
  },
}
</script>

<style lang="scss">
@import './delivery-returns-information';
</style>
